const Settings = () => import("./views/Settings.vue");
const ManageRecruiterSettings = () =>
  import("./views/ManageRecruiterSettings.vue");

const CreateManageRecruiterSettings = () =>
  import("./views/CreateManageRecruiterSettings.vue");

const EditManageRecruiterSettings = () =>
  import("./views/EditManageRecruiterSettings.vue");

const ManageEmailTemplates = () => import("./views/ManageEmailTemplates.vue");

export default [
  {
    path: "recruiter-settings",
    component: Settings,
  },
  {
    path: "manage-recruiter-settings",
    component: ManageRecruiterSettings,
  },
  {
    path: "manage-recruiter-settings/create",
    component: CreateManageRecruiterSettings,
  },
  {
    path: "manage-recruiter-settings/edit/:id",
    component: EditManageRecruiterSettings,
  },
  {
    path: "manage-email-templates",
    component: ManageEmailTemplates,
  },
];
